import { render } from "./FilterOption.vue?vue&type=template&id=20b0030c&scoped=true"
import script from "./FilterOption.vue?vue&type=script&lang=js"
export * from "./FilterOption.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=20b0030c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b0030c"]])

export default __exports__